// extracted by mini-css-extract-plugin
module.exports = {"total":"WindowImage_total__3_xzC","buttonRight":"WindowImage_buttonRight__2NPD8"};